/* Theme-owned startup adapter for the verified fetch-test-app-88 pipe/onlylength bundles.
 * The app continues to own configuration rendering, pricing and cart operations.
 * Load with defer immediately after <body>, after Shopify's head-injected app script.
 */
(function () {
  'use strict';
  if (window.aluConfiguratorStartup) return;
  // The configurator extension reads alloy option labels as legacy values.
  // Keep the friendly labels visible and expose canonical values during its events.
  function bridgeLegacyAlloyLabels() {
    if (window.__avAlloyTextBridge) return;
    window.__avAlloyTextBridge = true;
    var plateScript = Array.from(document.scripts).find(function (script) {
      return /\/fetch-test-app-88\/assets\/app-plate\.js(?:\?|$)/.test(script.src);
    });
    if (plateScript) {
      ['calcPrice', 'changeLengthAndWidth', 'sendConfig'].forEach(function (name) {
        var original = window[name];
        if (typeof original !== 'function') return;
        window[name] = function () {
          var select = document.getElementById('legierung-select');
          var changed = select ? Array.from(select.options).filter(function (option) {
            return option.textContent !== option.value;
          }).map(function (option) {
            var entry = { option: option, label: option.textContent };
            option.textContent = option.value;
            return entry;
          }) : [];
          try {
            return original.apply(this, arguments);
          } finally {
            changed.forEach(function (entry) {
              if (entry.option.parentElement === select && entry.option.textContent === entry.option.value) {
                entry.option.textContent = entry.label;
              }
            });
          }
        };
      });
      return;
    }
    function normalize() {
      var select = document.getElementById('legierung-select');
      if (!select) return null;
      var labels = Array.prototype.map.call(select.options, function (option) { return option.textContent; });
      Array.prototype.forEach.call(select.options, function (option) { option.textContent = option.value; });
      return function restore() {
        Array.prototype.forEach.call(select.options, function (option, index) { option.textContent = labels[index]; });
      };
    }
    function needsBridge(target) {
      if (!target || !target.matches) return false;
      if (target.matches('#legierung-select, #length, #amount, .pklist-length-input')) return true;
      return !!(target.closest && target.closest('.product-form__submit, .input-number-increment, .input-number-decrement'));
    }
    ['change', 'input', 'keyup', 'keydown', 'click'].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        if (!needsBridge(event.target)) return;
        var restore = normalize();
        if (restore) setTimeout(restore, 0);
      }, true);
    });
  }
  bridgeLegacyAlloyLabels();
  var appScript = Array.from(document.scripts).find(function (script) {
    return /\/fetch-test-app-88\/assets\/app-(pipe|onlylength)\.js(?:\?|$)/.test(script.src);
  });
  if (!appScript) return;
  var lengthInput = document.getElementById('length');
  var container = lengthInput && lengthInput.closest('.pk-container');
  var productId = container && container.querySelector('#product-id');
  if (!container || !/^\d+$/.test(productId && productId.textContent.trim())) return;
  if (!window.$inputLength || !['prepareConfigurator', 'calcPrice', 'doneTypingLength', 'getTranslation'].every(function (name) {
    return typeof window[name] === 'function';
  })) {
    showUnavailable();
    return;
  }
  var onlyLength = /\/app-onlylength\.js(?:\?|$)/.test(appScript.src);
  var fixedPv = /\/products\/pv-profile(?:\/|$)/.test(window.location.pathname);
  var originalPrepare = window.prepareConfigurator;
  var originalCalcPrice = window.calcPrice;
  var originalDoneTyping = window.doneTypingLength;
  var originalDoneTypingInList = window.doneTypingLengthInList;
  var state = { state: 'idle', attempts: 0, start: start };
  var pending = null;
  var controller = null;
  var generation = 0;
  var suspended = false;
  var timers = new Map();
  var suspendedInputs = [];
  var historyKey = '__aluConfiguratorStartup';
  var acknowledgedLength = null;
  var historyRestore = readHistoryConfiguration();
  var notifyingRestoredInputs = false;
  var maxAttempts = 3;
  var timeoutMs = 8000;
  var lockedControls = new Map();
  var english = document.documentElement.lang.toLowerCase().indexOf('en') === 0;
  var messages = english ? {
    loading: 'Loading configuration…',
    error: 'Configuration could not be loaded. Please try again.',
    exhausted: 'Configuration is unavailable. Please reload this page later.',
    retry: 'Try again'
  } : {
    loading: 'Konfiguration wird geladen …',
    error: 'Konfiguration konnte nicht geladen werden. Bitte erneut versuchen.',
    exhausted: 'Konfiguration derzeit nicht verfügbar. Bitte Seite später neu laden.',
    retry: 'Erneut versuchen'
  };
  var status = document.createElement('div');
  status.id = 'av-configurator-status';
  status.setAttribute('data-av-configurator-status', '');
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  status.style.cssText = 'padding:12px 0;line-height:1.5';
  var message = document.createElement('span');
  var retry = document.createElement('button');
  retry.id = 'av-configurator-retry';
  retry.type = 'button';
  retry.className = 'btn';
  retry.style.cssText = 'display:block;margin-top:8px';
  retry.textContent = messages.retry;
  retry.addEventListener('click', function () { start(true); });
  status.append(message, retry);
  container.prepend(status);
  var statusViews = [{ element: status, message: message, button: retry }];
  var listPanel = document.getElementById('tab-listenansicht');
  if (listPanel) {
    var listStatus = status.cloneNode(true);
    listStatus.id += '-list';
    var listRetry = listStatus.querySelector('button');
    listRetry.id += '-list';
    listRetry.addEventListener('click', function () { start(true); });
    listPanel.prepend(listStatus);
    statusViews.push({ element: listStatus, message: listStatus.querySelector('span'), button: listRetry });
  }
  window.aluConfiguratorStartup = state;
  window.removeEventListener('pageshow', originalPrepare);
  window.prepareConfigurator = function () { return start(false); };

  function configuratorControls() {
    return document.querySelectorAll('.pk-container input, .pk-container select, .pk-container .product-form__submit, .pklist-row input, .pklist-row .product-form__submit');
  }

  function showState(next) {
    state.state = next;
    container.setAttribute('aria-busy', String(next === 'loading'));
    statusViews.forEach(function (view) {
      view.element.hidden = next === 'ready';
      view.element.style.display = view.element.hidden ? 'none' : '';
      view.button.hidden = next !== 'error' || state.attempts >= maxAttempts;
      view.button.style.display = view.button.hidden ? 'none' : 'block';
      view.button.disabled = next === 'loading';
      view.message.textContent = next === 'loading' ? messages.loading : state.attempts < maxAttempts ? messages.error : messages.exhausted;
    });
    if (next === 'ready') {
      lockedControls.forEach(function (disabled, element) { element.disabled = disabled; });
      lockedControls.clear();
    } else {
      configuratorControls().forEach(function (element) {
        if (!lockedControls.has(element)) lockedControls.set(element, element.disabled);
        element.disabled = true;
      });
    }
  }

  function clearPrice() {
    var price = document.getElementById('price');
    if (price) {
      price.textContent = window.getTranslation('price-warning');
      price.classList.remove('active');
    }
    var notice = document.getElementById('pricenotice');
    if (notice) notice.classList.remove('active');
  }

  function selectedVariant() {
    if (onlyLength) return window.configuration_json;
    var diameter = document.getElementById('durchmesser-select').value;
    var alloy = document.getElementById('legierung-select').value;
    return window.configuration_json.find(function (variant) {
      return variant.Abmessung === diameter && variant.Legierung == alloy;
    });
  }

  function withLegacyAlloyLabels(callback) {
    var select = document.getElementById('legierung-select');
    if (!select) return callback();
    var labels = Array.prototype.map.call(select.options, function (option) { return option.textContent; });
    Array.prototype.forEach.call(select.options, function (option) { option.textContent = option.value; });
    try { return callback(); } finally {
      Array.prototype.forEach.call(select.options, function (option, index) { option.textContent = labels[index]; });
    }
  }

  window.calcPrice = function () {
    if (state.state !== 'ready' || !selectedVariant()) { clearPrice(); return null; }
    var receiver = this;
    var args = arguments;
    return withLegacyAlloyLabels(function () { return originalCalcPrice.apply(receiver, args); });
  };
  window.doneTypingLength = function () {
    if (state.state !== 'ready') return;
    acknowledgedLength = null;
    if (!onlyLength) window.changeLength();
    window.enforceMaxLength(window.$inputLength, window.maxLength);
    return originalDoneTyping.apply(this, arguments);
  };
  window.doneTypingLengthInList = function (id) {
    if (state.state !== 'ready') return;
    var field = document.getElementById(id);
    if (field) window.enforceMaxLength(window.$inputLength.constructor(field), Number(field.dataset.maxlaenge));
    return originalDoneTypingInList.apply(this, arguments);
  };
  ['sendConfig', 'sendConfigFromList', 'incrementQuantity', 'decrementQuantity', 'accept5mmShorter', 'decline5mmShorter'].forEach(function (name) {
    var original = window[name];
    if (typeof original !== 'function') return;
    window[name] = function () {
      if (state.state !== 'ready') return;
      var receiver = this;
      var args = arguments;
      var invoke = function () { return original.apply(receiver, args); };
      var result = (name === 'sendConfig' || name === 'sendConfigFromList')
        ? withLegacyAlloyLabels(invoke)
        : invoke();
      if (name === 'decline5mmShorter' && window.lengthInputID === 'length') acknowledgedLength = lengthInput.value;
      if (name === 'accept5mmShorter') window.calcPrice();
      return result;
    };
  });

  // These retained jQuery objects address the app's own event registry, even if
  // another extension subsequently installs a different global jQuery version.
  window.$inputLength.off('keyup keydown');
  if (window.$inputQuantity) window.$inputQuantity.off('keyup keydown');
  if (window.$listInputLength) window.$listInputLength.off('keyup keydown');

  function updateInput(target) {
    if (target.matches('.pklist-length-input')) window.doneTypingLengthInList(target.id);
    else if (target.id === 'length') window.doneTypingLength();
    else window.calcPrice();
  }

  function onInput(event) {
    if (notifyingRestoredInputs) return;
    var target = event.target;
    if (!target.matches('#length, #amount, .pklist-length-input')) return;
    if (state.state !== 'ready') return;
    if (target === lengthInput) acknowledgedLength = null;
    clearTimeout(timers.get(target));
    var update = function () {
      timers.delete(target);
      updateInput(target);
    };
    if (event.type === 'change') update();
    else timers.set(target, setTimeout(update, 700));
  }
  document.addEventListener('input', onInput);
  document.addEventListener('change', onInput);
  container.addEventListener('change', function (event) {
    if (state.state === 'ready' && event.target.matches('#durchmesser-select, #legierung-select')) {
      acknowledgedLength = null;
      window.calcPrice();
      selectSingleAlloy();
    }
  });
  document.addEventListener('click', function (event) {
    if (state.state !== 'ready' && !event.target.closest('[data-av-configurator-status]') && event.target.closest('.pk-container, .pklist-row')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  function validVariant(variant) {
    function nonnegative(value) { return value !== null && value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0; }
    return variant && typeof variant.SKU === 'string' && typeof variant.Abmessung === 'string' &&
      (typeof variant.Legierung === 'string' || Array.isArray(variant.Legierung)) &&
      nonnegative(variant.PreisMeter) && nonnegative(variant.KgMeter) &&
      Number(variant.MaxLaenge) >= 10 && Number.isFinite(Number(variant.MaxLaenge)) &&
      (variant.Saegekosten == null || nonnegative(variant.Saegekosten));
  }

  function readHistoryConfiguration() {
    try {
      var navigation = window.performance.getEntriesByType('navigation')[0];
      var saved = window.history.state && window.history.state[historyKey];
      if (navigation && navigation.type === 'back_forward' && saved && saved.version === 1 &&
          saved.productId === productId.textContent.trim() && saved.kind === (onlyLength ? 'onlylength' : 'pipe')) return saved;
    } catch (_) { /* History and navigation metadata are optional browser capabilities. */ }
    return null;
  }

  function saveHistoryConfiguration() {
    if (state.state !== 'ready') return;
    var variant = selectedVariant();
    var amountInput = document.getElementById('amount');
    if (!amountInput) return;
    try {
      var existing = window.history.state;
      // Preserve a third party's non-object state instead of changing its type.
      if (existing !== null && (typeof existing !== 'object' || Array.isArray(existing))) return;
      var merged = Object.assign({}, existing);
      if (!variant) {
        delete merged[historyKey];
        window.history.replaceState(merged, '');
        return;
      }
      merged[historyKey] = {
        version: 1,
        productId: productId.textContent.trim(),
        kind: onlyLength ? 'onlylength' : 'pipe',
        sku: variant.SKU,
        diameter: variant.Abmessung,
        alloy: onlyLength ? String(variant.Legierung) : document.getElementById('legierung-select').value,
        length: lengthInput.value,
        amount: amountInput.value,
        acknowledgedStockLength: acknowledgedLength === lengthInput.value && [1000, 1500, 2000].indexOf(Number(lengthInput.value)) !== -1
      };
      window.history.replaceState(merged, '');
    } catch (_) { /* Saving must not interfere with leaving the page. */ }
  }

  function restoreHistoryConfiguration(data) {
    var saved = historyRestore;
    historyRestore = null;
    if (!saved || typeof saved.length !== 'string' || typeof saved.amount !== 'string' ||
        !Number.isFinite(Number(saved.length)) || !Number.isFinite(Number(saved.amount))) return null;
    var variants = onlyLength ? [data] : data;
    var variant = variants.find(function (entry) {
      return entry.SKU === saved.sku && entry.Abmessung === saved.diameter && entry.Legierung == saved.alloy;
    });
    if (!variant) return null;
    if (!onlyLength) {
      document.getElementById('durchmesser-select').value = saved.diameter;
      window.changeAlloy();
      document.getElementById('legierung-select').value = saved.alloy;
    }
    lengthInput.value = saved.length;
    document.getElementById('amount').value = saved.amount;
    return saved;
  }

  function applyConfiguration(data) {
    if (onlyLength ? !validVariant(data) : !Array.isArray(data) || !data.length || !data.every(validVariant)) {
      throw new Error('Invalid configurator response');
    }
    window.configuration_json = data;
    var restored;
    if (onlyLength) {
      window.maxLength = data.MaxLaenge;
      window.$inputLength.attr({ max: data.MaxLaenge, placeholder: 'max. ' + data.MaxLaenge + ' mm' });
      restored = restoreHistoryConfiguration(data);
    } else {
      data.sort(function (a, b) { a = a.SKU.toLowerCase(); b = b.SKU.toLowerCase(); return a < b ? -1 : a > b ? 1 : 0; });
      window.loadDiameterOptions(data);
      if (fixedPv) {
        var fixedVariant = data[0];
        var dimensionSelect = document.getElementById('durchmesser-select');
        var alloySelect = document.getElementById('legierung-select');
        if (fixedVariant && dimensionSelect) {
          dimensionSelect.value = fixedVariant.Abmessung;
          window.changeAlloy();
          if (alloySelect) {
            alloySelect.value = Array.isArray(fixedVariant.Legierung) ? fixedVariant.Legierung[0] : fixedVariant.Legierung;
          }
        }
      } else {
        window.changeAlloy();
      }
      restored = restoreHistoryConfiguration(data);
      if (!restored && !fixedPv) window.fillPresets(data);
      window.changeLength();
      selectSingleAlloy();
      showFixedPvSummary();
      initZDimensionGuidance();
    }
    return restored;
  }


  function showFixedPvSummary() {
    if (!fixedPv || container.querySelector('[data-av-fixed-pv-summary]')) return;
    var lengthField = lengthInput.closest('.pk-input-container');
    if (!lengthField || !lengthField.parentNode) return;
    var summary = document.createElement('p');
    summary.setAttribute('data-av-fixed-pv-summary', '');
    summary.textContent = english ? '40 × 40 mm · silver · EN AW-6063' : '40 × 40 mm · Silber · EN AW-6063';
    lengthField.parentNode.insertBefore(summary, lengthField);
  }

  function initZDimensionGuidance() {
    if (!/\/z-profile(?:\/|$)|\/z-profil(?:\/|$)/.test(window.location.pathname)) return;
    if (document.querySelector('[data-av-z-dimension-guidance]')) return;
    var measureControl = document.getElementById('durchmesser-select');
    var alloyControl = document.getElementById('legierung-select');
    var measureField = document.querySelector('.vz-config-measure') || (measureControl && measureControl.closest('.pk-input-container'));
    var alloyField = document.querySelector('.vz-config-alloy') || (alloyControl && alloyControl.closest('.pk-input-container'));
    if (!measureField || !alloyField || !alloyField.parentNode) return;

    var guidance = document.createElement('div');
    guidance.setAttribute('data-av-z-dimension-guidance', '');

    var sequence = document.createElement('strong');
    sequence.textContent = 'Maßfolge: A × B × C × D';
    guidance.appendChild(sequence);

    var explanation = document.createElement('span');
    explanation.textContent = 'Schenkelmaß × Höhe × Schenkelmaß × Materialstärke';
    guidance.appendChild(explanation);

    var example = document.createElement('span');
    example.textContent = '17 × 25 × 17 × 2 mm entspricht A × B × C × D';
    guidance.appendChild(example);

    var drawing = document.querySelector('a[href*="Z-Profil2"], a[aria-label*="Zeichnerische Darstellung"]');
    if (drawing && drawing.getAttribute('href')) {
      var drawingLink = document.createElement('a');
      drawingLink.href = drawing.getAttribute('href');
      drawingLink.target = '_blank';
      drawingLink.rel = 'noopener';
      drawingLink.textContent = 'Maßzeichnung ansehen';
      guidance.appendChild(drawingLink);
    }

    alloyField.parentNode.insertBefore(guidance, alloyField.nextSibling);
  }

  [500, 1500, 3000].forEach(function (delay) {
    setTimeout(function () {
      initZDimensionGuidance();
      selectSingleAlloy();
    }, delay);
  });

  function selectSingleAlloy() {
    if (onlyLength || !Array.isArray(window.configuration_json)) return;
    var alloys = [];
    window.configuration_json.forEach(function (variant) {
      var values = Array.isArray(variant.Legierung) ? variant.Legierung : [variant.Legierung];
      values.forEach(function (value) {
        var text = String(value || '');
        if (text && alloys.indexOf(text) === -1) alloys.push(text);
      });
    });
    if (alloys.length !== 1) return;
    var alloySelect = document.getElementById('legierung-select');
    if (!alloySelect) return;
    var option = Array.prototype.slice.call(alloySelect.options).find(function (entry) { return entry.value === alloys[0]; });
    if (option) alloySelect.value = alloys[0];
  }

  function clearLoadingButtons() {
    document.querySelectorAll('.pk-container .product-form__submit, .pklist-row .product-form__submit').forEach(function (button) {
      button.classList.remove('action-button--loading');
    });
  }

  function start(manualRetry) {
    if (pending) return pending;
    if (state.state === 'ready') return Promise.resolve(true);
    if (state.attempts >= maxAttempts || state.state === 'error' && manualRetry !== true) return Promise.resolve(false);
    var requestGeneration = ++generation;
    var requestController = new AbortController();
    controller = requestController;
    state.attempts += 1;
    showState('loading');
    clearPrice();
    var timeout = setTimeout(function () { requestController.abort(); }, timeoutMs);
    pending = (async function () {
      try {
        var response = await fetch('/apps/aluverkauf-produktkonfigurator/load-config?productId=' + encodeURIComponent(productId.textContent.trim()), { signal: requestController.signal });
        if (!response.ok) throw new Error('Configurator HTTP ' + response.status);
        var data = await response.json();
        if (requestGeneration !== generation || requestController.signal.aborted) return false;
        var restored = applyConfiguration(data);
        showState('ready');
        selectSingleAlloy();
        showFixedPvSummary();
      initZDimensionGuidance();
        clearLoadingButtons();
        if (lengthInput.value) window.doneTypingLength();
        else window.calcPrice();
        if (restored && restored.acknowledgedStockLength === true && restored.length === lengthInput.value &&
            [1000, 1500, 2000].indexOf(Number(lengthInput.value)) !== -1) window.decline5mmShorter();
        if (restored) {
          // Notify existing theme previews without reopening an acknowledged
          // stock-length warning or scheduling our own input validation again.
          notifyingRestoredInputs = true;
          try {
            [lengthInput, document.getElementById('amount')].forEach(function (field) {
              field.dispatchEvent(new Event('input', { bubbles: true }));
            });
          } finally { notifyingRestoredInputs = false; }
        }
        return true;
      } catch (error) {
        if (requestGeneration === generation) {
          window.configuration_json = null;
          clearLoadingButtons();
          showState('error');
          console.warn('Configurator configuration unavailable:', error.name);
        }
        return false;
      } finally {
        clearTimeout(timeout);
        if (requestGeneration === generation) { pending = null; controller = null; }
      }
    })();
    return pending;
  }

  window.addEventListener('pagehide', function () {
    saveHistoryConfiguration();
    suspendedInputs = Array.from(timers.keys());
    timers.forEach(clearTimeout);
    timers.clear();
    if (controller) {
      ++generation;
      controller.abort();
      controller = null;
      pending = null;
      state.attempts -= 1;
      state.state = 'idle';
      suspended = true;
    }
  });
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    if (state.state === 'ready') {
      clearLoadingButtons();
      suspendedInputs.forEach(updateInput);
      suspendedInputs = [];
      window.calcPrice();
    } else if (suspended) {
      suspended = false;
      start(false);
    }
  });
  start(false);

  function showUnavailable() {
    // The app request itself can fail, while this independent theme asset loads.
    // Do not leave a permanent spinner or let inline buttons call absent code.
    window.aluConfiguratorStartup = { state: 'unavailable', attempts: 0, start: function () { return Promise.resolve(false); } };
    if (typeof window.prepareConfigurator === 'function') window.removeEventListener('pageshow', window.prepareConfigurator);
    var isEnglish = document.documentElement.lang.toLowerCase().indexOf('en') === 0;
    var scopes = [container, document.getElementById('tab-listenansicht')].filter(Boolean);
    scopes.forEach(function (scope, index) {
      var notice = document.createElement('div');
      notice.id = 'av-configurator-unavailable' + (index ? '-list' : '');
      notice.setAttribute('role', 'alert');
      notice.setAttribute('data-av-configurator-status', '');
      notice.style.cssText = 'padding:12px 0;line-height:1.5';
      notice.textContent = isEnglish ? 'The configurator could not start. Please reload this page.' : 'Konfigurator konnte nicht gestartet werden. Bitte Seite neu laden.';
      var reload = document.createElement('button');
      reload.id = 'av-configurator-reload' + (index ? '-list' : '');
      reload.type = 'button';
      reload.className = 'btn';
      reload.style.cssText = 'display:block;margin-top:8px';
      reload.textContent = isEnglish ? 'Reload page' : 'Seite neu laden';
      reload.addEventListener('click', function () { window.location.reload(); });
      notice.append(reload);
      scope.prepend(notice);
    });
    configuratorControls().forEach(function (element) { element.disabled = true; });
    document.querySelectorAll('.pk-container .product-form__submit, .pklist-row .product-form__submit').forEach(function (button) {
      button.classList.remove('action-button--loading');
    });
    ['sendConfig', 'sendConfigFromList'].forEach(function (name) { window[name] = function () {}; });
    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-av-configurator-status]') && event.target.closest('.pk-container, .pklist-row')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  }
})();

/* Keep the EN AW-5083 plate and the precision-milled cast plate distinct in the alloy selector. */
(function () {
  var observedSelect = null;
  function distinguishPlateAlloy() {
    var select = document.getElementById('legierung-select');
    if (!select) return;
    Array.prototype.forEach.call(select.options, function (option) {
      if (String(option.value || '').trim() === 'AlMg4,5Mn Guss feinstgefräst') {
        var label = 'EN AW-5083 (AlMg4,5Mn Guss feinstgefräst)';
        if (option.textContent !== label) option.textContent = label;
      }
    });
    if (select === observedSelect) return;
    observedSelect = select;
    if (window.MutationObserver) {
      new MutationObserver(distinguishPlateAlloy).observe(select, { childList: true, subtree: true });
    }
  }
  document.addEventListener('DOMContentLoaded', distinguishPlateAlloy);
  document.addEventListener('change', distinguishPlateAlloy, true);
  distinguishPlateAlloy();
})();
